import { render, staticRenderFns } from "./Centres.vue?vue&type=template&id=525782da"
import script from "./Centres.vue?vue&type=script&lang=js"
export * from "./Centres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports